(function () {
  function apply() {
    var have = window.EL_SLOTS || [];
    document.querySelectorAll('image-slot[id]').forEach(function (el) {
      if (have.indexOf(el.id) < 0) return;
      var want = window.ELA + 'slot-' + el.id + '.webp';
      if (el.getAttribute('src') !== want) el.setAttribute('src', want);
    });
  }
  apply();
  var q = false;
  new MutationObserver(function () { if (q) return; q = true; requestAnimationFrame(function () { q = false; apply(); }); }).observe(document.documentElement, { childList: true, subtree: true });
})();
